export default __webpack_public_path__ + "static/referral_and_evaluation-a369b4ea185e84710f66556f36181486.jpeg";